import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, unwrap } from "../api/client";
import { ErrorBox } from "../components/ErrorBox";
import { setSlot } from "../lib/identity";

/** /login#t=vp_… → a browser session; the token never appears in a query string or server log. Logging in adds this
 * identity to the browser (people already logged in here stay logged in) and binds this tab to it. */
export function LoginPage() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const [error, setError] = useState<unknown>(null);
  const [token, setToken] = useState("");
  const started = useRef(false);

  async function login(t: string) {
    try {
      const me = await unwrap(api.POST("/api/auth/login", { body: { token: t } }));
      window.history.replaceState(null, "", "/login");
      setSlot(me.slot ?? null);
      await qc.resetQueries();
      nav(me.home ?? "/board/videos", { replace: true });
    } catch (e) {
      setError(e);
    }
  }

  useEffect(() => {
    if (started.current) return; // StrictMode runs effects twice; log in once
    started.current = true;
    const m = /(?:^#|&)t=([^&]+)/.exec(window.location.hash);
    if (m?.[1]) void login(decodeURIComponent(m[1]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="login">
      <h1>Vezérlőpult login</h1>
      <p>Logging in adds you to this browser; anyone already logged in here stays logged in in their own tabs.</p>
      <ErrorBox error={error} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          void login(token);
        }}
      >
        <label htmlFor="token">Token</label>
        <input id="token" type="password" value={token} onChange={(e) => setToken(e.target.value)} autoComplete="off"
          data-testid="login-token" />
        <button type="submit" data-testid="login-submit">Log in</button>
      </form>
    </main>
  );
}
